import { strCode } from "../localizations/strCode";

const deviceTypeOptions = [
  { id: "CHARGER", value: strCode.CHARGER_LABEL },
  { id: "HOLDER", value: strCode.HOLDER_LABEL },
  { id: "MONO", value: strCode.MONO_LABEL }
];

export const deltaDeviceTypeOptions = [
  { id: "DEVICE-CONTROL", value: strCode.DEVICE_CONTROL_LABEL },
  { id: "DEVICE-ENGINE", value: strCode.DEVICE_ENGINE_LABEL }
];

export const ilumaDeviceTypeOptions = [
  { id: "HOLDER-CONTROL", value: strCode.HOLDER_CONTROL_LABEL },
  { id: "HOLDER-ENGINE", value: strCode.HOLDER_ENGINE_LABEL }
];

export const allDeviceTypeOption = {
  id: "all-device-types",
  value: strCode.ALL_DEVICE_TYPES_LABEL
};

export default deviceTypeOptions;
